import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-178">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" data-id="element-179" />

          {/* Modal Container */}
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none" data-id="element-180">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="w-full max-w-2xl bg-slate-900 border border-yellow-500/50 rounded-xl shadow-2xl shadow-black/50 overflow-hidden pointer-events-auto relative" data-id="element-181">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-slate-800 bg-slate-900/50" data-id="element-182">
                <h3 className="text-2xl font-bold text-yellow-500 font-serif tracking-wide" data-id="element-183">
                  {title}
                </h3>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-800 text-slate-400 hover:text-yellow-500 transition-colors" aria-label="Close modal" data-id="element-184">
                  <X className="w-6 h-6" data-id="element-185" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8 max-h-[70vh] overflow-y-auto custom-scrollbar text-slate-300 leading-relaxed" data-id="element-186">
                {children}
              </div>

              {/* Decorative Corner Accents */}
              <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-yellow-500/20 rounded-tl-xl pointer-events-none" data-id="element-187"></div>
              <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-yellow-500/20 rounded-br-xl pointer-events-none" data-id="element-188"></div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}